export const PATHS = {
  ROOT: "/",
  AUTH_LOGIN: "/login",
 
  CALL_LOBBY: "/communications/calls",
 
  // Communications & Messaging
  COMMUNICATIONS_MESSAGES: "/communications/messages",
  COMMUNICATIONS_THREAD: "/communications/messages/:threadId",
 
  TRAVELLERS: "/travellers",
  TRAVELLERS_PRE: "/travellers/pre-registrations",
  TRAVELLERS_PRE_NEW: "/travellers/pre-registrations/new",

  TRAVELLERS_DOC_VERIFY_LIST: "/traveller/document-verification",
  TRAVELLERS_DOC_VERIFY_CREATE: "/traveller/document-verification/new",
  TRAVELLERS_CLEARANCE_CERTS: "/traveller/clearance-certificates",
  TRAVELLERS_CLEARANCE_CERTS_CREATE: "/traveller/clearance-certificates/new",

  QR: "/qr",
  TRAVELLERS_SCREENING_LIST: "/traveller/screening",
  TRAVELLERS_SCREENING_CREATE: "/traveller/screening/new",
  TRAVELLERS_SCREENING_VIEW: "/traveller/screening/:id",
  TRAVELLERS_SCREENING_EDIT: "/traveller/screening/:id/edit",
  PASSENGER_ILL_REPORTS_LIST: "/passenger/ill-passenger-reports",
  PASSENGER_ILL_REPORTS_CREATE: "/passenger/ill-passenger-reports/new",
  PASSENGER_ILL_REPORTS_VIEW: "/passenger/ill-passenger-reports/:id",
  PASSENGER_ILL_REPORTS_EDIT: "/passenger/ill-passenger-reports/:id/edit",

  CONVEYANCE_ROAD_INSPECTIONS_LIST: "/conveyance/bus-truck-inspections",
  CONVEYANCE_ROAD_INSPECTIONS_CREATE: "/conveyance/bus-truck-inspections/new",
  CONVEYANCE_BUS_CHECKLISTS_LIST: "/conveyance/bus-checklists",
  CONVEYANCE_BUS_CHECKLISTS_CREATE: "/conveyance/bus-checklists/new",
  CONVEYANCE_BUS_CHECKLISTS_VIEW: "/conveyance/bus-checklists/:checklistId",
  CONVEYANCE_BUS_CHECKLISTS_EDIT: "/conveyance/bus-checklists/:checklistId/edit",
  PASSENGER_TRAIN_INSPECTIONS_LIST: "/conveyance/passenger-train-inspections",
  PASSENGER_TRAIN_INSPECTIONS_CREATE: "/conveyance/passenger-train-inspections/new",
  PASSENGER_TRAIN_INSPECTIONS_VIEW: "/conveyance/passenger-train-inspections/:id",
  PASSENGER_TRAIN_INSPECTIONS_EDIT: "/conveyance/passenger-train-inspections/:id/edit",
  VEHICLE_HAZARD_CHECKLISTS_LIST: "/conveyance/vehicle-hazard-checklists",
  VEHICLE_HAZARD_CHECKLISTS_CREATE: "/conveyance/vehicle-hazard-checklists/new",
  VEHICLE_HAZARD_CHECKLISTS_VIEW: "/conveyance/vehicle-hazard-checklists/:id",
  VEHICLE_HAZARD_CHECKLISTS_EDIT: "/conveyance/vehicle-hazard-checklists/:id/edit",
  CONVEYANCE_HOLDING_BAY_LOGS: "/conveyance/holding-bay-logs",
  CONVEYANCE_HOLDING_BAY_LOGS_CREATE: "/conveyance/holding-bay-logs/new",
  CONVEYANCE_CHECKLISTS: "/conveyance/checklists",
  CASES_OPEN_LIST: "/cases",
  CASES_OPEN_CREATE: "/cases/new",
  CASES_PENDING: "/cases/pending",
  CASES_PENDING_CREATE: "/cases/pending/new",
  CASES_ESCALATED_LIST: "/cases/escalated",
  CASES_ESCALATED_CREATE: "/cases/escalated/new",
  SANITATION_CERTS: "/conveyance/sanitation-certificates",
  SANITATION_CERTS_CREATE: "/conveyance/sanitation-certificates/new",

    CARGO_INSPECTION_OUTCOMES_LIST: "/cargo/inspection-outcomes",
  CARGO_INSPECTION_OUTCOMES_CREATE: "/cargo/inspection-outcomes/new",
  CARGO_HAZARDOUS_SUBSTANCES_LIST: "/cargo/hazardous-substances",
  CARGO_HAZARDOUS_SUBSTANCES_CREATE: "/cargo/hazardous-substances/new",
  CARGO_CERTIFICATES_LIST: "/cargo/certificates",
  CARGO_CERTIFICATES_CREATE: "/cargo/certificates/new",
  CARGO_WAREHOUSE_INSPECTIONS_LIST: "/cargo/warehouse-inspections",
  CARGO_WAREHOUSE_INSPECTIONS_CREATE: "/cargo/warehouse-inspections/new",
  CARGO_HOLDING_BAY_INSPECTIONS_LIST: "/cargo/holding-bay-inspections",
  CARGO_HOLDING_BAY_INSPECTIONS_CREATE: "/cargo/holding-bay-inspections/new",
  CARGO_TIRE_INSPECTIONS_LIST: "/cargo/tire-inspections",
  CARGO_TIRE_INSPECTIONS_CREATE: "/cargo/tire-inspections/new",
  CARGO_TIRE_INSPECTIONS_VIEW: "/cargo/tire-inspections/:id",
  CARGO_TIRE_INSPECTIONS_EDIT: "/cargo/tire-inspections/:id/edit",
  
  PREMISES_WATER_QUALITY_LIST: "/premises/water-quality",
  PREMISES_WATER_QUALITY_CREATE: "/premises/water-quality/new",
  EH_NOISE_MONITORING_LIST: "/environment/noise-monitoring",
  EH_NOISE_MONITORING_CREATE: "/environment/noise-monitoring/new",
  EH_HEALTH_EDUCATION_LIST: "/environment/health-education",
  EH_HEALTH_EDUCATION_CREATE: "/environment/health-education/new",
  EH_TRAINING_MEETINGS_LIST: "/environment/trainings-meetings",
  EH_TRAINING_MEETINGS_CREATE: "/environment/trainings-meetings/new",
    HR_DOA_CASES_LIST: "/human-remains/doa-cases",
  HR_DOA_CASES_CREATE: "/human-remains/doa-cases/new",
  EQUIPMENT_WATER_SAMPLING_LIST: "/equipment/water-sampling-kits",
  EQUIPMENT_WATER_SAMPLING_CREATE: "/equipment/water-sampling-kits/new",
  EQUIPMENT_FOOD_SAMPLING_LIST: "/equipment/food-sampling-kits",
  EQUIPMENT_FOOD_SAMPLING_CREATE: "/equipment/food-sampling-kits/new",
  EQUIPMENT_RAPID_DIAGNOSTIC_LIST: "/equipment/rapid-diagnostic-kits",
  EQUIPMENT_RAPID_DIAGNOSTIC_CREATE: "/equipment/rapid-diagnostic-kits/new",
  EQUIPMENT_RADIATION_MONITORS_LIST: "/equipment/radiation-monitors",
  EQUIPMENT_RADIATION_MONITORS_CREATE: "/equipment/radiation-monitors/new",
  EQUIPMENT_MONITORING_BADGES_LIST: "/equipment/monitoring-badges",
  EQUIPMENT_MONITORING_BADGES_CREATE: "/equipment/monitoring-badges/new",
   VECTOR_TYRE_INSPECTIONS_LIST: "/surveillance/tyres",
  VECTOR_TYRE_INSPECTIONS_CREATE: "/surveillance/tyres/new",
    VECTOR_DERATING_CERTIFICATES_LIST: "/surveillance/derating-certificates",
  VECTOR_DERATING_CERTIFICATES_CREATE: "/surveillance/derating-certificates/new",
  // Surveillance Cases (traveller monitoring)
  SURVEILLANCE_CASES_LIST: "/surveillance/cases",
  SURVEILLANCE_CASES_CREATE: "/surveillance/cases/new",
  SURVEILLANCE_CASES_VIEW: "/surveillance/cases/:id",
  // Aircraft clearance (disinfection + free pratique)
  CONVEYANCE_CLEARANCE_LIST: "/conveyance/clearance",
  CONVEYANCE_CLEARANCE_CREATE: "/conveyance/clearance/new",
  // Detention certificates (e.g., tyres, hazardous consignments)
  VECTOR_DETENTION_CERTS_LIST: "/vector/detention-certificates",
  VECTOR_DETENTION_CERTS_CREATE: "/vector/detention-certificates/new",
  VECTOR_DETENTION_CERTS_VIEW: "/vector/detention-certificates/:id",
  // Ovitrap monitoring
  VECTOR_OVITRAPS_LIST: "/vector/ovitraps",
  VECTOR_OVITRAPS_CREATE: "/vector/ovitraps/new",

  // Dashboards
  DASHBOARDS_PORT_OPERATIONS: "/dashboards/port-operations",
  DASHBOARDS_TRAVELLER_HEALTH: "/dashboards/traveller-health",
  DASHBOARDS_CONVEYANCE_OVERSIGHT: "/dashboards/conveyance-oversight",
  DASHBOARDS_CARGO_HOLDING_BAY: "/dashboards/cargo-holding-bay",
  DASHBOARDS_HUMAN_REMAINS: "/dashboards/human-remains",
  DASHBOARDS_VECTOR_SURVEILLANCE: "/dashboards/vector-surveillance",
  DASHBOARDS_ENVIRONMENTAL_HEALTH: "/dashboards/environmental-health",
  DASHBOARDS_OUTBREAKS_EPR: "/dashboards/outbreaks-epr",
  VECTOR_RESIDUAL_SPRAY_LIST: "/vector/residual-spraying",
  VECTOR_RESIDUAL_SPRAY_CREATE: "/vector/residual-spraying/new",
  VECTOR_RESIDUAL_SPRAY_VIEW: "/vector/residual-spraying/:id",
  VECTOR_RESIDUAL_SPRAY_EDIT: "/vector/residual-spraying/:id/edit",
  TRAVELLER_YF_LIST: "/traveller/yellow-fever-checks",
  TRAVELLER_YF_CREATE: "/traveller/yellow-fever-checks/new",
  VECTOR_TYRES_REPORT_MONTHLY: "/vector/reports/used-tyres/monthly",
  OUTBREAK_ALERTS: "/outbreak/alerts",
  OUTBREAK_ALERTS_CREATE: "/outbreak/alerts/new",
  OUTBREAK_ALERTS_VIEW: "/outbreak/alerts/:id",
  OUTBREAK_ALERTS_EDIT: "/outbreak/alerts/:id/edit",
  OUTBREAK_CONTACT_TRACING: "/outbreak/contact-tracing",
  OUTBREAK_CONTACT_TRACING_CREATE: "/outbreak/contact-tracing/new",
  OUTBREAK_CONTACT_TRACING_CASE: "/outbreak/contact-tracing/:caseId",
  OUTBREAK_DRILLS: "/outbreak/drills",
  OUTBREAK_DRILLS_CREATE: "/outbreak/drills/new",
  OUTBREAK_DRILLS_VIEW: "/outbreak/drills/:id",
  OUTBREAK_DRILLS_EDIT: "/outbreak/drills/:id/edit",
  OUTBREAK_LOGBOOK: "/outbreak/logbook",
  OUTBREAK_LOGBOOK_CREATE: "/outbreak/logbook/new",
  OUTBREAK_LOGBOOK_VIEW: "/outbreak/logbook/:id",
  OUTBREAK_LOGBOOK_EDIT: "/outbreak/logbook/:id/edit",
  OUTBREAK_RUMOUR_REGISTER: "/outbreak/rumour-register",
  OUTBREAK_RUMOUR_REGISTER_CREATE: "/outbreak/rumour-register/new",
  OUTBREAK_RUMOUR_REGISTER_VIEW: "/outbreak/rumour-register/:id",
  OUTBREAK_RUMOUR_REGISTER_EDIT: "/outbreak/rumour-register/:id/edit",
  OUTBREAK_EMERGENCY_PLANS: "/outbreak/emergency-plans",
  OUTBREAK_EMERGENCY_PLANS_CREATE: "/outbreak/emergency-plans/new",
  OUTBREAK_EMERGENCY_PLANS_VIEW: "/outbreak/emergency-plans/:id",
  OUTBREAK_EMERGENCY_PLANS_EDIT: "/outbreak/emergency-plans/:id/edit",

    REPORTS_CENTER_LIST: "/reports",
  REPORTS_CENTER_CREATE: "/reports/new",

  THDF_CASES: "/travellers/thdf-cases",
   THDF_CASES_CREATE: "/travellers/thdf-cases/add",
  INSPECTIONS: "/inspections",
  INSPECTIONS_CARGO: "/inspections/cargo",
    INSPECTIONS_CARGO_CREATE: "/inspections/cargo/add",
  INSPECTIONS_PREMISES: "/inspections/premises",
   INSPECTIONS_PREMISES_CREATE: "/inspections/premises/add",
  INSPECTIONS_AIRCRAFT: "/inspections/aircraft-checklists",
  INSPECTIONS_FOOD_WATER: "/inspections/food-water",
  INSPECTIONS_FOOD_WATER_CREATE: "/inspections/food-water/add",
  INSPECTIONS_SANITARY: "/inspections/sanitary",
    INSPECTIONS_SANITARY_CREATE: "/inspections/sanitary/add",
    INSPECTIONS_SANITARY_REINSPECTION: "/inspections/sanitary/:id/reinspection",
  WASTE: "/waste",
  WASTE_LOGS: "/waste/logs",
    WASTE_LOGS_CREATE: "/waste/logs/add",
  WASTE_ACTIONS: "/waste/corrective-actions",
  LICENSING: "/licensing",
  LICENCES_PREMISES: "/licensing/premise-licences",
   LICENCES_PREMISES_CREATE: "/licensing/premise-licences/add",
  FOOD_HANDLER_CERTS: "/licensing/food-handler-certificates",
    FOOD_HANDLER_CERTS_CREATE: "/licensing/food-handler-certificates/add",
  LICENCE_EXPIRY: "/licensing/expiry-watchlist",
  VECTOR: "/vector",
  VECTOR_MONITORING: "/vector/monitoring",
  VECTOR_MONITORING_CREATE: "/vector/monitoring/add",
  VECTOR_MONITORING_VIEW: "/vector/monitoring/:id",
  VECTOR_MONITORING_EDIT: "/vector/monitoring/:id/edit",
  VECTOR_TYRES_LIST: "/vector/tyres",
  VECTOR_TYRES_CREATE: "/vector/tyres/new",
  VECTOR_RODENTS_LIST: "/vector/rodents",
  VECTOR_CONTROL: "/vector/control",
  VECTOR_ALERTS: "/vector/alerts",
  HUMAN_REMAINS: "/human-remains",
  HR_CLEARANCE_LIST: "/human-remains/clearance-list",
  HR_CLEARANCE: "/human-remains/clearance",
  HR_CERTIFICATES: "/human-remains/certificates",
  HR_CERTIFICATES_VIEW: "/human-remains/certificates/view",
  CONVEYANCES: "/conveyances",
  CONVEYANCES_VESSELS: "/conveyances/vessels",
  CONVEYANCES_AIRCRAFT: "/conveyances/aircraft",
  CONVEYANCES_AIRCRAFT_ADD: "/conveyances/aircraft-new",
  AIRCRAFT_CHECKLIST_VIEW: "/aircraft-checklists/:checklistId",
  AIRCRAFT_CHECKLIST_EDIT: "/aircraft-checklists/:checklistId/edit",

  GENERAL_DECLARATIONS_CREATE: "/conveyances/general-declarations/new",
  GENERAL_DECLARATIONS: "/conveyances/general-declarations/list",
  VEHICLE_GENERAL_DECLARATIONS_LIST: "/conveyances/vehicle-general-declarations",
  VEHICLE_GENERAL_DECLARATIONS_CREATE: "/conveyances/vehicle-general-declarations/new",
  FINANCE: "/finance",
  FINANCE_RECEIPTS: "/finance/receipts",
  FINANCE_AUDIT: "/finance/payments-audit",
  FINANCE_TARIFFS: "/finance/tariffs-fees",
  NOTIFICATIONS: "/notifications",
  NOTIFY_LICENCE_EXPIRY: "/notifications/licence-expiry",
  NOTIFY_CORRECTIVE: "/notifications/corrective-actions",
  NOTIFY_THDF: "/notifications/thdf-escalations",
  REPORTS: "/reports",
  REPORTS_DASHBOARDS: "/reports/dashboards",
  REPORTS_SCREENING: "/reports/screening-summary",
  REPORTS_HUMAN_REMAINS: "/reports/human-remains",
  REPORTS_AIRCRAFT: "/reports/aircraft-canisters",
  REPORTS_CARGO: "/reports/cargo-hazardous",
  REPORTS_DAILY_AUDIT: "/reports/daily-audit",
  REPORTS_CUSTOM: "/reports/custom",
  REPORTS_CONVEYANCE_INSPECTION: "/reports/conveyance/inspection",
  REPORTS_GENERAL_DECLARATIONS: "/reports/conveyance/general-declarations",
  REPORTS_CARGO_SUMMARY: "/reports/cargo/summary",
  REPORTS_CARGO_CLEARANCE: "/reports/cargo/clearance",
  REPORTS_CARGO_HAZARDOUS: "/reports/cargo/hazardous-register",
  REPORTS_CARGO_CONDEMNATION: "/reports/cargo/condemnation",
  REPORTS_HUMAN_REMAINS_SUMMARY: "/reports/human-remains/summary",
  REPORTS_TRAVELLER_SCREENING: "/reports/traveller/screening",
  REPORTS_TRAVELLER_DISEASE_CONDITIONS: "/reports/traveller/disease-conditions",
  REPORTS_ENVIRONMENTAL_PREMISES: "/reports/environment/premises",
  REPORTS_ENVIRONMENTAL_SANITARY_SCORECARD: "/reports/environment/sanitary-scorecard",
  REPORTS_WATER_QUALITY: "/reports/water-quality",
  REPORTS_NOISE_QUALITY: "/reports/noise-quality",
  REPORTS_AIR_QUALITY: "/reports/air-quality",
  REPORTS_VECTOR_SURVEILLANCE: "/reports/vector/surveillance",
  REPORTS_VECTOR_USED_TYRES: "/reports/vector/used-tyres",
  REPORTS_VECTOR_CONTROL: "/reports/vector/control-actions",
  REPORTS_WASTE_MANAGEMENT: "/reports/waste-management",
  REPORTS_AUDIT_TRAIL: "/reports/audit-trail",
  REPORTS_CAPTURE_SUMMARY: "/reports/capture-summary",
  ADMIN: "/admin",
  ADMIN_USERS: "/admin/users-roles",
  ADMIN_ROLE_MATRIX: "/admin/users-roles/role-matrix",
  ADMIN_POE_CREATE: "/admin/users-roles/poe-onboarding",
  ADMIN_USER_PROFILE: "/admin/users-roles/profile",
  ADMIN_HAZARDOUS_BANNED_SUBSTANCES_LIST: "/admin/hazardous/banned-substances",
  ADMIN_HAZARDOUS_BANNED_SUBSTANCES_CREATE: "/admin/hazardous/banned-substances/new",
  ADMIN_CARGO_ALERT_CONFIGURATION: "/admin/cargo/alert-configuration",
  ADMIN_MASTER_DATA: "/admin/master-data",
  ADMIN_AUDIT: "/admin/audit-logs",
  SETTINGS: "/admin/settings",
  ADMIN_DOC_REQUIREMENTS_LIST: "/admin/document-requirements",
  ADMIN_DOC_REQUIREMENTS_CREATE: "/admin/document-requirements/new",
  ADMIN_DOC_REQUIREMENTS_VIEW: "/admin/document-requirements/:id",
  ADMIN_DOC_REQUIREMENTS_EDIT: "/admin/document-requirements/:id/edit",
  ADMIN_COUNTRY_DOC_LIST: "/admin/country-documentation",
  ADMIN_COUNTRY_DOC_CREATE: "/admin/country-documentation/new",
  ADMIN_COUNTRY_DOC_VIEW: "/admin/country-documentation/:id",
  ADMIN_COUNTRY_DOC_EDIT: "/admin/country-documentation/:id/edit",
  HELP: "/help",
    LOGOUT: "/help",
  NOT_FOUND: "*",
  
    REPORTS_PORT_OPS: "/reports/port-ops",
 REPORTS_VECTOR: "/reports/vector",
  REPORTS_EXPORTS_COC: "/reports/exports/coc",
  REPORTS_EXPORTS_EXPIRY: "/reports/exports/expiry",
  // Traveller Health

THDF_CASES_LIST: "/travellers/thdf", 
TRAVELLER_SCREENING_LIST: "/travellers/screenings",
TRAVELLER_CERTIFICATES_LIST: "/travellers/certificates",
QUARANTINE_REFERRALS_LIST: "/travellers/quarantine-referrals",
DOC_VERIFICATION_LIST: "/travellers/doc-verification",
TRAVELLER_PRIMARY_SCREENING_LIST: "/traveller/primary-screening",
TRAVELLER_PRIMARY_SCREENING_CREATE: "/traveller/primary-screening/new",
TRAVELLER_PRIMARY_SCREENING_VIEW: "/traveller/primary-screening/:id",
TRAVELLER_PRIMARY_SCREENING_EDIT: "/traveller/primary-screening/:id/edit",

// Conveyance Oversight
CONVEYANCES_LIST: "/conveyances",
CREW_MANIFESTS_LIST: "/conveyances/crew-manifests",
SANITATION_INSPECTIONS_LIST: "/conveyances/inspections",
SANITATION_CERTIFICATES_LIST: "/conveyances/certificates",

// Cargo & Hazardous Substances
CARGO_CONSIGNMENTS_LIST: "/cargo/consignments",
CARGO_INSPECTIONS_LIST: "/cargo/inspections",
SEARCH_BAY_INSPECTIONS_LIST: "/cargo/search-bay",
ROAD_TANKER_INSPECTIONS_LIST: "/cargo/tankers",
REJECTION_CERTIFICATES_LIST: "/cargo/rejections",
DESTRUCTION_CERTIFICATES_LIST: "/cargo/destructions",
SMUGGLED_GOODS_LIST: "/cargo/smuggled-goods",

// Human Remains
HUMAN_REMAINS_LIST: "/remains/clearance",
DOA_CASES_LIST: "/remains/doa",
MORTUARY_TRANSPORT_LINKS: "/remains/mortuary-links",
HUMAN_REMAINS_CERTIFICATES_LIST: "/remains/certificates",
HR_DOC_VERIFY_LIST: "/human-remains/document-verification",
HR_DOC_VERIFY_CREATE: "/human-remains/document-verification/new",

// Environmental Health
PREMISES_INSPECTIONS_LIST: "/eh/premises",
HYGIENE_AUDITS_LIST: "/eh/hygiene-audits",
FOOD_INSPECTIONS_LIST: "/eh/food-inspections",
FOOD_HANDLER_CERTIFICATES_LIST: "/eh/food-handlers",
WATER_QUALITY_LIST: "/eh/water",
WASTE_MANAGEMENT_LIST: "/eh/waste",
AIR_QUALITY_MONITORING_LIST: "/eh/air-quality",

// Vector Surveillance
VECTOR_SURVEILLANCE_LIST: "/vector/surveillance",
TYRE_INSPECTIONS_LIST: "/vector/tyres",
RODENT_INSPECTIONS_LIST: "/vector/rodents",
DERATING_CERTIFICATES_LIST: "/vector/derating",

// Outbreaks & EPR
CASE_REGISTRATIONS_LIST: "/epr/cases",
OUTBREAK_ALERTS_LIST: "/epr/alerts",
CONTACT_TRACING_LIST: "/epr/contacts",
LINE_LIST_EXPORTS: "/epr/line-lists",
EPR_PLANS_LIST: "/epr/plans",
DRILL_SIMULATIONS_LIST: "/epr/drills",
INCIDENT_LOGBOOK_LIST: "/epr/incidents",
EVENT_ESCALATIONS_LIST: "/epr/escalations",

// Finance & Fees
FEE_SCHEDULES_LIST: "/finance/fees",
FEE_LINKAGES_LIST: "/finance/fee-links",
RECEIPTS_LIST: "/finance/receipts",
DAILY_RECONCILIATIONS_LIST: "/finance/reconciliation",
ZIMRA_INTEGRATIONS_LIST: "/finance/zimra",

// Reporting & Dashboards
REPORTS_OPERATIONAL: "/reports/operational",
DASHBOARD_COMPLIANCE: "/reports/compliance",
DASHBOARD_FINANCIAL: "/reports/financial",
DASHBOARD_VECTOR_TRENDS: "/reports/vector-trends",
REPORTS_DHIS2_EXPORT: "/reports/dhis2",
AUDIT_TRAIL_REPORTS: "/reports/audit-trails",

// Admin, RBAC & Docs
USERS_LIST: "/admin/users",
ROLES_PERMISSIONS_LIST: "/admin/roles",
  AUDIT_LOGS_LIST: "/admin/audit-logs",
  ADVISORY_BULLETINS_LIST: "/admin/advisories",
  SOP_REPOSITORY_LIST: "/admin/sops-regulations",
PERMIT_VALIDATIONS_LIST: "/admin/permits",
MAKER_CHECKER_LIST: "/admin/maker-checker", 

DASHBOARDS_FINANCE_REVENUE: "/dashboards/finance/revenue-collections",
DASHBOARDS_FINANCE_ZIMRA: "/dashboards/finance/zimra-integration",
DASHBOARDS_FINANCE_RECON: "/dashboards/finance/reconciliation-variances",

DASHBOARDS_ADMIN_AUDIT: "/dashboards/admin/audit-trails",
DASHBOARDS_ADMIN_MAKER_CHECKER: "/dashboards/admin/maker-checker",
DASHBOARDS_ADMIN_COMPLIANCE: "/dashboards/admin/compliance-status",

DASHBOARDS_OPS_PORT_DAILY: "/dashboards/ops/port-performance-daily",
DASHBOARDS_OPS_COMPLIANCE: "/dashboards/ops/compliance",
DASHBOARDS_OPS_RISK: "/dashboards/ops/risk-alerts",

REPORTS_EXPORTS_TYRES: "/reports/exports/used-tyres-monthly",
REPORTS_EXPORTS_GD: "/reports/exports/general-declaration-register",
REPORTS_EXPORTS_SURVEILLANCE: "/reports/exports/surveillance-register",
EH_INDOOR_AIR_QUALITY_CREATE: "/environmental-health/indoor-air-quality/create",
EH_INDOOR_AIR_QUALITY_LIST: "/environmental-health/indoor-air-quality/list",
} as const;

type QueryParamValue = string | number | boolean | null | undefined;

const isPresent = (value: QueryParamValue): value is string | number | boolean =>
  value !== null && value !== undefined;

export const appendQueryParams = (
  path: string,
  params: Record<string, QueryParamValue>,
): string => {
  const queryIndex = path.indexOf("?");
  const basePath = queryIndex >= 0 ? path.slice(0, queryIndex) : path;
  const existingQuery = queryIndex >= 0 ? path.slice(queryIndex + 1) : "";
  const searchParams = new URLSearchParams(existingQuery);

  Object.entries(params).forEach(([key, value]) => {
    if (isPresent(value)) {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `${basePath}?${queryString}` : basePath;
};

export type CrudRouteMode = "view" | "edit";

export const buildModePath = (
  createPath: string,
  id: string | number,
  mode: CrudRouteMode,
): string => appendQueryParams(createPath, { id: String(id), mode });

export const buildViewPath = (createPath: string, id: string | number): string =>
  buildModePath(createPath, id, "view");

export const buildEditPath = (createPath: string, id: string | number): string =>
  buildModePath(createPath, id, "edit");

export const buildSanitaryReinspectionPath = (id: string | number): string =>
  PATHS.INSPECTIONS_SANITARY_REINSPECTION.replace(":id", encodeURIComponent(String(id)));
